module.exports = __webpack_public_path__ + "static/media/ido.43668e66.svg";